import { render, staticRenderFns } from "./BudgetAccordion.vue?vue&type=template&id=22df5f94&"
import script from "./BudgetAccordion.vue?vue&type=script&lang=js&"
export * from "./BudgetAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports